import { Endpoint } from '@business/api/endpoint';
import { CompactIdeaResponse } from '@business/entities/idea';
import { R } from '@core/utils/r';
import { CompactIdeaCategoryResponse, IdeaCommentResponse, IdeaId } from './../../entities/idea/IdeaResponse';
import { IdeasFormData } from '@modules/ideas/IdeasPage/IdeasPage';

export function fetchIdeas(options?: IdeasFormData) {
  const params = R.objectCompact(options);
  return Endpoint.get<CompactIdeaResponse[]>(`@gc/ideas`, { params });
}

export function createIdea(data: Partial<CompactIdeaResponse>) {
  return Endpoint.post<CompactIdeaResponse>(`@gc/ideas`, { data });
}

export function updateIdea(ideaId: IdeaId, data: Partial<CompactIdeaResponse>) {
  return Endpoint.patch<CompactIdeaResponse>(`@gc/ideas/${ideaId}`, { data });
}

export function deleteIdea(ideaId: IdeaId) {
  return Endpoint.delete<void>(`@gc/ideas/${ideaId}`);
}

export function fetchIdea(ideaId: IdeaId) {
  return Endpoint.get<CompactIdeaResponse>(`@gc/ideas/idea/${ideaId}`);
}

export function searchIdeas(search: string) {
  return Endpoint.get<CompactIdeaResponse[]>(`@gc/ideas/search-idea`, { params: { search } });
}

// Comments

export function fetchComments(options: { search?: string } = {}) {
  const params = R.objectCompact({ search: options.search });
  return Endpoint.get<IdeaCommentResponse[]>(`@gc/ideas/comments`, { params });
}

export function createComment(ideaId: IdeaId, data: Partial<IdeaCommentResponse>) {
  return Endpoint.post<IdeaCommentResponse>(`@gc/ideas/comment/${ideaId}`, { data });
}

export function updateComment(id: string, data: Partial<IdeaCommentResponse>) {
  return Endpoint.patch<IdeaCommentResponse>(`@gc/ideas/comment/${id}`, { data });
}

export function deleteComment(id: string) {
  return Endpoint.delete<void>(`@gc/ideas/comment/${id}`);
}

export function fetchComment(id: string) {
  return Endpoint.get<IdeaCommentResponse>(`@gc/ideas/comment/${id}`);
}

export function postVote(ideaId: IdeaId, detailPage?: boolean) {
  return Endpoint.post<CompactIdeaResponse>(`@gc/ideas/vote/${ideaId}`, { data: { detailPage } });
}

export function fetchCategories() {
  return Endpoint.get<CompactIdeaCategoryResponse[]>(`@gc/ideas/categories`, {});
}
